import styled from 'styled-components';

export const GridChildren = styled.div`
  .default-type-object-title,
  .default-type-array-title {
    display: none; /* designs have no titles for sections */
  }
  .default-type-array-children .default-type-array-item {
    &:first-child {
      border-top: none;
    }
    border: none;
    padding-top: 0px;
  }
  .default-type-object-children {
    /* styles hazmat card */
    border: ${p => `1px solid ${p.theme.colors.heavyLineOutline}`};
    border-radius: 5px;
    padding: 8px;
  }
  .default-type-object-children:empty {
    /* hides above style if the object is present, but with nothing inside */
    display: none;
  }
  .default-type-boolean-value,
  .default-type-integer-value,
  .default-type-null-value,
  .default-type-number-value,
  .default-type-string-value {
    overflow-wrap: anywhere;
    display: flex;
  }
  .default-type-array-title,
  .default-type-object-title,
  .default-type-boolean,
  .default-type-integer,
  .default-type-null,
  .default-type-number,
  .default-type-string {
    padding-left: 8px;
    padding-right: 8px;
  }
`;

export const Grid = styled.div`
  padding: 15px 0px;
`;
